<template>
  <section id="aos-section5" class="relative flex size-full flex-col items-center overflow-hidden overflow-hidden px-5">
    <OptimizedImage
      base-path="image/home/bg_gradation_dark01"
      file-name="bg_gradation_dark01"
      alt="bg_gradation_dark01"
      img-format="jpg"
      image-class="absolute left-0 top-0 size-full object-cover"
    />

    <div class="gn-container gap-9 pb-20 pt-[60px] lg:gap-12 lg:pt-[120px]">
      <div data-aos="fade-up">
        <i18n-t :keypath="titleKey" tag="p" class="gn-text-3xl font-bold text-white md:whitespace-pre-line">
          <template #parent>
            <span class="font-extrabold">{{ $t(titleBoldKey) }}</span>
          </template>
        </i18n-t>
      </div>

      <div class="relative w-full lg:py-16" data-aos="fade-up">
        <!-- 카드 그리드 컨테이너 -->
        <div class="relative grid size-full gap-3 lg:grid-cols-5">
          <template v-for="num in 5" :key="`card_desktop_${num}`">
            <!-- 카드 -->
            <div
              :class="[
                zIndexClasses[num],
                'relative flex items-center gap-3 rounded-2xl bg-white/90 p-4 shadow backdrop-blur lg:flex-col lg:rounded-3xl lg:p-8'
              ]"
            >
              <img
                :src="useDynamicImage(`svg/icon_difficult-${num}.svg`)"
                :alt="$t(`main.section5.cardList.text${num}`)"
                class="size-[50px] lg:size-20"
              />
              <span class="gn-text-lg whitespace-pre-line text-start font-medium lg:text-center">
                {{ $t(`main.section5.cardList.text${num}`) }}
              </span>

              <div
                v-if="num < 5"
                class="absolute -bottom-1.5 right-1/2 flex translate-x-1/2 translate-y-1/2 items-center justify-center lg:-right-1.5 lg:bottom-1/2"
              >
                <img src="~/assets/svg/icon_circle_plus.svg" alt="icon_circle_plus" class="sm:size-8 lg:size-10" />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import OptimizedImage from '~/components/common/OptimizedImage.vue'

defineProps({
  titleKey: {
    type: String,
    default: 'main.section5.title'
  },
  titleBoldKey: {
    type: String,
    default: 'main.section5.parent'
  }
})

const zIndexClasses = {
  1: 'z-50',
  2: 'z-40',
  3: 'z-30',
  4: 'z-20',
  5: 'z-10'
}
</script>

<style lang="scss" scoped></style>
